import { render, staticRenderFns } from "./BrowseStandardSelector.vue?vue&type=template&id=6cfde5a7"
import script from "./BrowseStandardSelector.vue?vue&type=script&lang=js"
export * from "./BrowseStandardSelector.vue?vue&type=script&lang=js"
import style0 from "./BrowseStandardSelector.vue?vue&type=style&index=0&id=6cfde5a7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports